import { /*QueryGetPreferences,*/ QueryGetPreferencesFromCache } from '../../graphql'
import { deepMerge } from '../../util'

export default {
  Preferences: {
    needs_sync: () => false
  },
  Mutation: {
    updatePreferences: (_, {lang, state}, {cache} /*getCacheKey}*/) => {
      const previousState = cache.readQuery({
        query: QueryGetPreferencesFromCache
      })
      const { getPreferences } = previousState
      const preferences = {
        ...previousState,
        getPreferences: {
          ...getPreferences,
          needs_sync: true,
          lang: (lang === null ? getPreferences.lang : lang),
          state: (state === null ? getPreferences.state : JSON.stringify(
            deepMerge(JSON.parse(getPreferences.state), JSON.parse(state))))
        }
      }
      cache.writeData({data: preferences})
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/apollo/resolvers/index.js